module.exports = __webpack_public_path__ + "img/transactionsTxt.6ae47657.png";